import React from 'react'
import {
  logUtil,
  toSlugStringUtil
} from 'packages/src'
import Chip from 'components/Chip'
import Button from 'components/Button'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import joinUnderscoreStringUtil from 'utils/string/join-underscore/index.js'

const ANALYTIC_EVENT = {
  CLICK_TAG: 'CLICK_TAG'
}

/**
 * @param props
 * @param props.tag
 * @param props.analyticsEventPrefix
 * @param props.urlPrefix
 * @param props.onClickTag
 * @param props.isSelected
 * @param props.hasFixedHeight
 * @param props.label
 * @param props.useSlug
 * @returns {Element}
 * @constructor
 */
export default function Tag (props) {
  const {
    tag,
    analyticsEventPrefix,
    urlPrefix,
    onClick,
    useSlug
  } = props

  const label = props.label || tag
  const debugProps = {
    props,
    label
  }

  logUtil('Tag').debug('debugProps=', debugProps)
  const handleClick = () => {
    const event = joinUnderscoreStringUtil(analyticsEventPrefix, ANALYTIC_EVENT.CLICK_TAG)
    logEventAnalyticsUtil(event, { tag })

    onClick?.(tag)
  }

  const propsToPass = {}
  if (props.hasFixedHeight) {
    const height = '31.5px'
    const maxHeight = height
    propsToPass.hoverableProps = {
      height,
      maxHeight
    }
  }

  if (
    urlPrefix &&
    useSlug
  ) {
    propsToPass.url = `${urlPrefix}${toSlugStringUtil(tag)}`
  } else if (urlPrefix) {
    propsToPass.url = `${urlPrefix}${tag}`
  }

  return (
    <Button
      key={tag}
      onClick={handleClick}
      height='auto'
      className='tag'
      {...propsToPass}
    >
      <Chip
        py='0.5rem'
        px='0.5rem'
        isSelected={props.isSelected}
      >
        {label}
      </Chip>
    </Button>
  )
}
